import { jsx as _jsx } from "react/jsx-runtime";
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useLayoutEffect, useRef, useState } from 'react';
/** A display-only hint: inserting a node here would change the typed trigger's selection range. */
export function TypedCommandMenuPlaceholder({ placeholder }) {
    const [editor] = useLexicalComposerContext();
    const hintRef = useRef(null);
    const [hidden, setHidden] = useState(false);
    const [hintStyle, setHintStyle] = useState();
    useLayoutEffect(() => {
        const root = editor.getRootElement();
        const hint = hintRef.current;
        if (root === null || hint === null)
            return;
        const container = hint.offsetParent;
        if (container === null)
            return;
        const position = () => {
            const selection = root.ownerDocument.getSelection();
            if (editor.isComposing() ||
                selection === null ||
                !selection.isCollapsed ||
                selection.rangeCount === 0 ||
                !root.contains(selection.anchorNode)) {
                setHidden(true);
                return;
            }
            const caret = selection.getRangeAt(0).getBoundingClientRect();
            const bounds = container.getBoundingClientRect();
            setHidden(caret.height === 0);
            setHintStyle({
                left: caret.right - bounds.left + container.scrollLeft,
                // A paragraph can run opposite to the UI locale; the hint follows its caret.
                transform: window.getComputedStyle(selection.anchorNode?.parentElement ?? root).direction === 'rtl'
                    ? 'translateX(-100%)'
                    : '',
                top: caret.top - bounds.top + container.scrollTop,
                font: window.getComputedStyle(root).font,
                // A collapsed DOM range measures the glyph, not the input's full line box.
                lineHeight: `${caret.height}px`,
            });
        };
        position();
        const unregister = editor.registerUpdateListener(position);
        const resizeObserver = new ResizeObserver(position);
        resizeObserver.observe(root);
        root.ownerDocument.addEventListener('scroll', position, true);
        window.addEventListener('resize', position);
        return () => {
            unregister();
            resizeObserver.disconnect();
            root.ownerDocument.removeEventListener('scroll', position, true);
            window.removeEventListener('resize', position);
        };
    }, [editor]);
    return (_jsx("span", { ref: hintRef, "aria-hidden": true, hidden: hidden, className: "text-tertiary pointer-events-none absolute select-none whitespace-pre", style: hintStyle, children: placeholder }));
}
//# sourceMappingURL=TypedCommandMenuPlaceholder.js.map